export class NothingToFetch extends Error {
  constructor() {
    super(`Nothing to fetch`);

    Object.setPrototypeOf(this, NothingToFetch.prototype);
    Error.captureStackTrace(this, this.constructor);
  }
}
